import { useState, useEffect } from 'react';

/**
 * Hook to detect if the user prefers reduced motion.
 * Listens to the `prefers-reduced-motion` media query.
 *
 * @returns true if user prefers reduced motion, false otherwise
 */
export function useReducedMotion(): boolean {
    const [prefersReduced, setPrefersReduced] = useState(() => {
        // SSR safety check
        if (typeof window === 'undefined') return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
        );

        const handleChange = (event: MediaQueryListEvent) => {
            setPrefersReduced(event.matches);
        };

        // Modern browsers
        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    return prefersReduced;
}
